import type { ChallengeService } from '@duck/api-definitions'

export type Severity = ChallengeService.ActivitySeverityEnum

/** Comma-separated HSL on purpose: echarts' parser cannot read the space-separated form (see chartChrome.ts). */
export const SEVERITY_COLOR: Record<Severity, string> = {
  info: 'hsl(214, 22%, 60%)',
  notable: 'hsl(38, 92%, 55%)',
  suspicious: 'hsl(22, 90%, 55%)',
  highly_suspicious: 'hsl(0, 78%, 55%)',
}
export const SEVERITY_BADGE_CLASS: Record<Severity, string> = {
  info: 'bg-muted text-foreground/80',
  notable: 'bg-warning/15 text-warning',
  suspicious: 'bg-orange-500/15 text-orange-600 dark:text-orange-400',
  highly_suspicious: 'bg-error/15 text-error',
}
export const BAND_CLASS: Record<ChallengeService.ActivityBandEnum, string> = {
  high: 'bg-success/15 text-success',
  medium: 'bg-warning/15 text-warning',
  low: 'bg-error/15 text-error',
}

export interface DurationUnits { s: string; m: string; h: string }

export const formatDuration = (ms: number, u: DurationUnits): string => {
  const s = Math.round(ms / 1000)
  if (s < 60) return `${s}${u.s}`
  const m = Math.floor(s / 60)
  if (m < 60) return `${m}${u.m} ${s % 60}${u.s}`
  return `${Math.floor(m / 60)}${u.h} ${m % 60}${u.m}`
}
